import React, { Component } from 'react'
import { Button, Input, message, notification, Popover } from "antd"
import SplitNote from './../../../shared/SplitNote'
import { updateNoteBatch } from "../../../../services/api/3dApi"

class BatchNote extends Component {
    state = {
        visible: false,
        note: this.props.note,
    }
    textAreaRef = React.createRef()
    _tempNote = this.props.note

    _hidePopover = () => {
        this.setState({
            visible: false,
        })
    }

    _handleVisibleChange = visible => {
        this.setState({
            visible,
        })
    }

    _handleChangeInput = e => {
        const { value } = e.target

        this._tempNote = value
    }

    _rqAddNote = async () => {
        try {
            const { orderId, refreshBatches } = this.props
            const payload = {
                content: this._tempNote,
            }

            const { data: response } = await updateNoteBatch(orderId, payload)

            const { success, error } = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                note: this._tempNote,
            })

            message.success('Đã thêm note')
            refreshBatches()
        } catch (e) {
            notification.error({
                message: 'ERROR',
                description: e.message,
                duration: 0,
            })
        } finally {
            this._hidePopover()
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { visible } = this.state
        if (prevState.visible !== visible) {
            if (!!visible) {
                setTimeout(() => {
                    this.textAreaRef.current.focus()
                }, 300)
            } else {
                setTimeout(() => {
                    this.textAreaRef.current = null
                }, 300)
            }
        }
    }

    render() {
        const { note } = this.props
        const { visible } = this.state

        const content = (
            <div>
                {
                    visible && <Input.TextArea
                        ref={this.textAreaRef}
                        defaultValue={note}
                        autoSize={{ minRows: 3, maxRows: 5 }}
                        onChange={this._handleChangeInput}
                    />
                }

                <div className='d-flex justify-content-end mt-1'>
                    <Button type='link' size='small' onClick={this._rqAddNote}>Lưu</Button>
                </div>
            </div>
        )

        return (
            <td className="note">
                {note !== undefined &&
                    <Popover content={<div style={{maxWidth: '300px', wordBreak: 'break-word'}}>{note}</div>} title="Note" trigger='hover'>
                        <label>
                            {note.length > 10 ? `${note.slice(0, 11)}...` : note}
                        </label>
                    </Popover>
                }
                <Popover visible={visible} onVisibleChange={this._handleVisibleChange} title='Note' content={content}
                    placement='bottom'
                    trigger='click'>
                    <Button type='link' icon='edit' />
                </Popover>
            </td>
        )
    }
}

export default BatchNote
